import  * as React from "react";
import { observer } from "mobx-react";  
import {IMultiShotControlParams} from "./IMultiShotControlParams";
import { PanelWithHighlightedResults } from "./PanelWithHighlightedResults/PanelWithHighlightedResults";
import { ShotsResults } from "./ShotsResults/ShotsResults";
import {IShotsResultsParams} from "./ShotsResults/IShotsResultsParams";
import { ISponsorDetailsProps } from "../SponsorDetails/ISponsorDetailsProps";
import { SponsorDetails } from "Components";
import { IPanelWithHighlightedResultsParams } from "./PanelWithHighlightedResults/IPanelWithHighlightedResultsParams";

export interface IMultiShotControlState {
    selectedTileAdditionalInformation: string | undefined;
}

@observer export class MultiShotControl extends React.Component<IMultiShotControlParams, IMultiShotControlState>{
    constructor(props: IMultiShotControlParams) {
        super(props, undefined);
        this.state = { selectedTileAdditionalInformation: undefined };
    }

    setAdditionalInfoUrl(url: string) {
        this.setState({ selectedTileAdditionalInformation: url });
    }

    private getPanelWithHighlightedResultsParams() {
        var self = this;
        const result: IPanelWithHighlightedResultsParams = {
            unitPresentation: this.props.unitPresentation,
            selectedGroupOfStrokes: this.props.selectedGroupOfStrokes,
            selectedStroke: this.props.selectedStroke,
            selectedAverage: this.props.selectedAverage,
            measurementParameters: this.props.measurementParameters,
            cleanSelectedShot: this.props.cleanSelectedShot,
            isWeb: this.props.isWeb,
            isIos: this.props.isIos,
            isTps: this.props.isTps,
            setAdditionalInfoUrl: self.setAdditionalInfoUrl.bind(self),
        };
        return result;
    }

    private getSponsorDetailsParams() {
        const result: ISponsorDetailsProps = {
            sponsors: this.props.sponsors,
            facilities: this.props.facilities,
            isWeb: this.props.isWeb,
            isTps: this.props.isTps
        };
        return result;
    }

    private getShotsResultsParams() {
        var self = this;

        const result: IShotsResultsParams = {
            reportKind: this.props.reportKind,
            individualPlayers: this.props.individualPlayers,
            measurementsData: this.props.measurementsData,
            displayStrokesGroup: this.props.displayStrokesGroup,
            unitPresentation: this.props.unitPresentation,
            measurementParameters: this.props.measurementParameters,
            isWeb: this.props.isWeb,
            selectedStroke: this.props.selectedStroke,
            selectedAverage: this.props.selectedAverage,
            selectedGroupOfStrokes: this.props.selectedGroupOfStrokes,
            selectShot: this.props.selectShot,
            selectVideo: this.props.selectVideo,
            hideSingleShot: this.props.hideSingleShot,
            selectAverage: this.props.selectAverage,
            collapseStrokesGroup: this.props.collapseStrokesGroup,
            disableTile: this.props.disableTile,
            tilesToDisplay: this.props.tilesToDisplay,
            addTile: this.props.addTile,
            loadTiles: this.props.loadTiles,
            updateUnitOnTiles: this.props.updateUnitOnTiles,
            changeUnit: this.props.changeUnit,
            setAdditionalInfoUrl: self.setAdditionalInfoUrl.bind(self),
            selectedUnit: this.props.selectedUnit,
            reportStore: this.props.reportStore
        };
        return result;
    }

    renderAdditionalInfoModal() {
        return <div className="modal fade" id="showAdditionalInfoOnTile" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    
                    <div className="modal-body">
                        <img src="Images/MultiGroupReport/Close_icon.svg" alt="" className="close-tiles-list-btn" data-dismiss="modal" aria-label="Close" />
                        <iframe src={this.state.selectedTileAdditionalInformation} frameBorder="0" title="Additional Information"></iframe>
                    </div>
                </div>
            </div>
        </div>;
    }

    render() {
        return <div className="MultiShotControl">
            <div className="tiles-and-sponsor-info hidden-print row">
                <PanelWithHighlightedResults {...this.getPanelWithHighlightedResultsParams() }></PanelWithHighlightedResults>
                {this.props.isWeb &&
                    <div className="hidden-print col-xs-12">
                        <SponsorDetails {...this.getSponsorDetailsParams() }></SponsorDetails>
                    </div>
                }
            </div>
            <ShotsResults {...this.getShotsResultsParams() }></ShotsResults>

            {this.renderAdditionalInfoModal()}
        </div>
    }
}
